import { Variant, VariationGroup } from 'editor/src/store/variants/types';

import { UNSELECTED_PAGE_COUNT } from '../reducer/setPageCountReducer';

import getDesignKey from './getDesignKey';

/**
 * The `designTemplates` key for one variant, with the page count normalised the
 * way templates are stored.
 *
 * Templates are requested (and therefore keyed) with the SELECTED page count —
 * see `checkForMissingTemplatesOperation` — not with whatever `pageCount` the
 * variant happens to carry. Deriving the key from the variant alone misses
 * every template on a page-count product, which then looks like a missing
 * template (GAPI-47583).
 */
export const getVariantDesignKey = (variant: Variant, selectedPageCount: number): string =>
  getDesignKey(variant.variation.productUid, {
    ...variant,
    pageCount: selectedPageCount === UNSELECTED_PAGE_COUNT ? undefined : selectedPageCount,
  });

/**
 * The variant that tells us whether a group already holds a design.
 *
 * NOTE: this is deliberately NOT the variant whose template a group's design is
 * built from — that is always `variationsInfo[0]`, see
 * `getNewDesignDataForGroup`. A group waiting on a newly selected size has that
 * size first and the previously selected one (holding the pre-edit design)
 * second; the design must target the new size, while "does this group have a
 * design at all?" must look at the old one. Collapsing the two makes the group
 * follow the wrong template.
 */
export const getGroupRepresentativeVariant = (group: VariationGroup): Variant =>
  group.variationsInfo.find((info) => !!info.designData) || group.variationsInfo[0];
